import {
  QBankStructureLevelCategory,
  type QBankStructureLevelItemWithLevel,
} from '@exam-management/qbs-provider';

import type { DisplayQBankStructureLevelItem, QBankStructureCVRaw } from '../types';

import { findLevelItemParentById } from './find-level-item-parent-by-id';

function flattenChildren(nodeArray: DisplayQBankStructureLevelItem[]) {
  const result: DisplayQBankStructureLevelItem[] = [];

  function recurse(nodes: DisplayQBankStructureLevelItem[]) {
    for (const node of nodes) {
      result.push(node);
      if (node.children && node.children.length > 0) {
        recurse(node.children);
      }
    }
  }

  recurse(nodeArray);
  return result;
}
export const transformQBankStructureLevelItemsToCV = (
  qBankStructureLevelItems: QBankStructureLevelItemWithLevel[],
) => {
  const sortedQBankStructureLevelItems = qBankStructureLevelItems.sort((a, b) => {
    if (a.qBankStructureLevel.level === b.qBankStructureLevel.level) {
      return a.order - b.order;
    }
    return a.qBankStructureLevel.level - b.qBankStructureLevel.level;
  });

  const filterOut = sortedQBankStructureLevelItems.filter(
    ({ qBankStructureLevel }) =>
      qBankStructureLevel.category !== QBankStructureLevelCategory.Course,
  );
  const items = filterOut.reduce<DisplayQBankStructureLevelItem[]>((acc, item) => {
    const newItem = { ...item, children: [] };
    if (!item.parentLevelItemId) {
      return [...acc, newItem];
    }

    const parentItem = findLevelItemParentById(acc, item.parentLevelItemId);
    if (!parentItem) {
      return [...acc, newItem];
    }

    if (!parentItem.children) {
      parentItem.children = [];
    }

    parentItem.children.push(newItem);
    return acc;
  }, []);
  return flattenChildren(items) as QBankStructureCVRaw[];
};
